// extracted by mini-css-extract-plugin
module.exports = {"tag":"_2787e5dfdf--tag--EIBZ3"};